import React, { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import DraggableList from 'components/DraggableList';
import { Button } from 'semantic-ui-react';
import CloseIcon from '../Icons/Close';

function ModifyProductOrder({
  onClose,
  products,
  updateDealerProductsOrder,
  dealer,
}) {
  const [tempProducts, setProducts] = useState([...products]);

  const onChange = newProducts => {
    setProducts(newProducts);
  };

  const saveOrder = async () => {
    await updateDealerProductsOrder({
      dealer: { id: dealer.id, penProducts: tempProducts },
    });
    onClose();
  };

  const columns = [
    {
      displayName: 'Name',
      format(product) {
        return product?.raw?.name;
      },
    },
    {
      displayName: 'Display',
      format(product) {
        return product.displayName;
      },
    },
    {
      displayName: 'Enabled',
      format(product) {
        return product.enabled ? 'Enabled' : 'Disabled';
      },
    },
  ];

  return (
    <Modal isOpen>
      <CloseIcon onClick={onClose} />
      <div className="product-order-container">
        <h2>Change product order</h2>
        <strong>
          This affects the order at which users will see these insurances
          products.
        </strong>
        <p>
          Drag and drop the products to the desired placement and save when
          done.
        </p>
        <DraggableList
          columns={columns}
          data={products}
          onChange={onChange}
          width={'40%'}
        />
        <Button onClick={saveOrder}>Save Order</Button>
      </div>
    </Modal>
  );
}

ModifyProductOrder.propTypes = {
  onClose: PropTypes.func,
  updateDealerProductsOrder: PropTypes.func,
  dealer: PropTypes.object,
  products: PropTypes.array,
};

export default ModifyProductOrder;
